import { useState } from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import Header from './Header';
import ScreenContent from './ScreenContent';
import BackButton from './BackButton';

const OnboardingFlow = () => {
    const {
        data,
        loading,
        error,
        getCurrentScreenPosition
    } = useOnboarding();

    const [contentOpacity] = useState(1);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '40px', color: '#ffffff' }}>
                <p>Loading...</p>
            </div>
        );
    }

    if (error) {
        const is404 = error.includes('not found') || error.includes('404');
        return (
            <div style={{ 
                textAlign: 'center', 
                padding: '40px', 
                color: '#ffffff',
                maxWidth: '600px',
                margin: '0 auto'
            }}>
                <h1 style={{ fontSize: '72px', margin: '20px 0' }}>
                    {is404 ? '404' : '⚠️'}
                </h1>
                <h2 style={{ marginBottom: '16px' }}>
                    {is404 ? 'Onboarding Not Found' : 'Error'}
                </h2>
                <p style={{ color: '#a1a1a1', lineHeight: '1.6' }}>{error}</p>
                {is404 && (
                    <p style={{ color: '#a1a1a1', marginTop: '20px' }}>
                        Please check the URL and try again.
                    </p>
                )}
            </div>
        );
    }

    if (!data) {
        return null;
    }

    return (
        <div id="screen-content">
            <Header />
            {getCurrentScreenPosition() > 0 && <BackButton />}
            <ScreenContent opacity={contentOpacity} />
        </div>
    );
};

export default OnboardingFlow;
